module.exports = __webpack_public_path__ + "media/argendata.205a946d.mp4";